module.exports = __webpack_public_path__ + "img/imgstone.8ab4830f.png";